"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = decorateOptions;

var _react = _interopRequireDefault(require("react"));

var _canopyStyleguideSofe = require("canopy-styleguide!sofe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function decorateOptions(opts) {
  if (_typeof(opts) !== 'object' || typeof opts.featureName !== 'string') {
    throw new Error("canopy-react-error-boundary decorator should be called with an opts object that has a featureName string. e.g. @ErrorBoundary({featureName: 'life'})");
  }

  return function decorateComponent(Comp) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(CanopyReactErrorBoundary, _React$Component);

      function CanopyReactErrorBoundary() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, CanopyReactErrorBoundary);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CanopyReactErrorBoundary)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "state", {
          caughtError: null,
          caughtErrorInfo: null,
          dismissed: false
        });

        return _this;
      }

      _createClass(CanopyReactErrorBoundary, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          if (!this.state.caughtError) {
            if (opts.noStrictMode || !_react["default"].StrictMode) {
              return _react["default"].createElement(Comp, this.props);
            } else {
              return _react["default"].createElement(_react["default"].StrictMode, null, _react["default"].createElement(Comp, this.props));
            }
          } else if (document.getElementById('canopy-react-error-boundary-modal')) {
            // Only show one application's error modal at a time
            return null;
          } else if (this.state.dismissed) {
            // Maybe they want to click on the navbar underneath the modal?
            return null;
          } else {
            return _react["default"].createElement("div", {
              className: "cps-modal",
              id: "canopy-react-error-boundary-modal"
            }, _react["default"].createElement("div", {
              className: "cps-modal__screen"
            }), _react["default"].createElement("div", {
              className: "cps-modal__dialog cps-card__height-3",
              style: {
                maxWidth: '100vw',
                transform: "translateX(-50%)",
                left: "50%"
              }
            }, _react["default"].createElement("div", {
              className: "cps-card__header cps-subheader-sm"
            }, _react["default"].createElement("span", null, "The ", opts.featureName, " feature is having problems"), _react["default"].createElement("a", {
              className: "cps-modal__dialog__close cps-icon cps-icon-close",
              onClick: function onClick() {
                return _this2.setState({
                  dismissed: false
                });
              }
            })), _react["default"].createElement("div", {
              className: "cps-card__body",
              style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }
            }, _react["default"].createElement("img", {
              src: "https://cdn.canopytax.com/images/ErrorState.svg",
              style: {
                width: '25%',
                padding: '16px 0'
              }
            }), _react["default"].createElement("div", {
              style: {
                fontSize: '20px',
                fontWeight: 'bold',
                textAlign: 'center'
              }
            }, "Looks like there was a problem"), _react["default"].createElement("div", {
              style: {
                textAlign: 'center'
              }
            }, "If the error continues, chat with support via the help center or call ", _react["default"].createElement("a", {
              href: "tel:855-558-8407"
            }, "855-558-8407"))), _react["default"].createElement("div", {
              className: "cps-modal__dialog__actions"
            }, _react["default"].createElement(_canopyStyleguideSofe.CprButton, {
              actionType: "primary",
              onClick: function onClick() {
                return window.history.back();
              }
            }, "Go back"), _react["default"].createElement(_canopyStyleguideSofe.CprButton, {
              actionType: "flat",
              onClick: function onClick() {
                return window.location.reload();
              }
            }, "Reload page"))));
          }
        }
      }, {
        key: "componentDidCatch",
        value: function componentDidCatch(err, info) {
          if (info && info.componentStack) {
            err.extra = Object.assign(err.extra || {}, {
              componentStack: info.componentStack
            });
          }

          setTimeout(function () {
            throw err;
          });
          this.setState({
            caughtError: err,
            caughtErrorInfo: info
          });
        }
      }]);

      return CanopyReactErrorBoundary;
    }(_react["default"].Component), _defineProperty(_class, "displayName", "CanopyReactErrorBoundary(".concat(opts.featureName, ")")), _temp;
  };
}
//# sourceMappingURL=canopy-react-error-boundary.js.map